import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import TablePager from "../../../components/table/TablePager";

// The admin orders list is served fifty to a page (controllers/
// orderController.js getOrdersPaginated LIMIT).
export const ORDERS_PAGE_SIZE = 50;

const Paginate = ({ page }) => {
  const { numberOfPages, totalOrders } = useSelector((state) => state.mobileOrders);
  const location = useLocation();

  // Keep every other query parameter (the list filters) when paging; a page
  // link that dropped them reset the filters on the second page.
  const hrefFor = (nextPage) => {
    const params = new URLSearchParams(location.search);
    params.set("page", String(nextPage));
    return `/admin/paginatedOrdersTable/?${params.toString()}`;
  };

  return (
    <TablePager
      page={page}
      pageCount={numberOfPages}
      totalItems={totalOrders}
      pageSize={ORDERS_PAGE_SIZE}
      itemNoun="orders"
      hrefFor={hrefFor}
    />
  );
};

export default Paginate;
